import React, { useContext, useState } from "react";
import { ExpressCheckoutElement, PaymentElement, useCheckout } from '@stripe/react-stripe-js';
import { ButtonSpinner, showAlertMsg } from "../../components/CommonMethod";
import { Context } from "../../components/Context";
import { useNavigate } from "react-router-dom";
import { onCheckoutSuccessEvent } from "./CheckoutSuccess";

const CustomCheckout = () => {
    const checkout = useCheckout();
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [, setContext] = useContext(Context);

    const handleSubmit = async () => {
        if (!checkout) return;
        setIsProcessing(true);
        const confirmResult = await checkout.confirm({
            redirect: 'if_required'
        });        

        if (confirmResult.type === 'success') {
            await onCheckoutSuccessEvent(`?stripe_session_id=${confirmResult.session.id}`, setContext, navigate);
        } else {
            showAlertMsg({ error: confirmResult.error.message || 'Opps something went wrong' });
        }
        setIsProcessing(false);
    };

    return (<>
        <form className="needs-validation" method="post" id="puchaseForm" noValidate autoComplete="off">
            <ExpressCheckoutElement />
            <PaymentElement id="payment-element" />
            <div className="col-sm-12 py-3 d-flex justify-content-end">
                <button type="button" disabled={(isProcessing)} className="btn btn-theme-primary minw-90 me-3" onClick={handleSubmit}>
                    <ButtonSpinner load={isProcessing} btnName={`Pay ${checkout.total.total.amount} now`} />
                </button>
            </div>
        </form>
    </>
    );
}

export default CustomCheckout;